export default __webpack_public_path__ + "static/hero_cloud_back-9526c2bf3f8ed8635682d3b98ff46863.png";